<template>
  <section class="poll-scene">
    <!-- background -->
    <div class="poll-scene__scenario">
      <!-- background -->
      <div class="poll-scene__newspaper"></div>
      <!-- logotype -->
      <div class="poll-scene__logotype" title="聯合報為你解密選舉數字">
        <SvgSymbol use="#logotype"/>
        <div class="poll-scene__logotype-left">
          <SvgSymbol use="#logotype-left"/>
        </div>
        <div class="poll-scene__logotype-right">
          <SvgSymbol use="#logotype-right"/>
        </div>
      </div>
    </div>

    <!-- intro -->
    <div class="poll-scene__intro">
      <span class="poll-scene__intro-text">選戰白熱化，候選人搶議題、刷版面、搏民心，聲量領先民調卻跌跌不休，民意到底站在誰那邊？</span>
    </div>

    <!-- scroll -->
    <div class="poll-scene__scroll" title="往下捲動" @click="onScrollClick">
      <div class="poll-scene__scroll-label">SCROLL</div>
      <div class="poll-scene__scroll-arrow">
        <SvgSymbol use="#arrow-down"/>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PollScene',
  methods: {
    onScrollClick (event) {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Click',
        'eventAction': 'Click',
        'eventLabel': `Scroll-to-topics`
      })
      this.$scrollTo('#competition', 500, { offset: 30 })
    }
  }
}
</script>

<style lang="scss">
.poll-scene {
  // @include use-layer(&);
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #7e93ce;
  overflow: hidden;

  .svg-symbol {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__scenario {
    position: relative;
    width: 100%;
    margin-top: 50px;
    @include use-fixed-ratio(1, 0.9);
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 80px;
      @include use-fixed-ratio(1, 0.85);
    }
    @include rwd($RWD_TABLET) {
      margin-top: 150px;
      @include use-fixed-ratio(1, 0.68);
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: 120px;
      @include use-fixed-ratio(1, 0.45);
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 100px;
      max-height: 645px;
    }
  }

  &__newspaper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #7e93ce url(~@/assets/newspaper-bg.jpg) repeat center center;
    overflow: hidden;

    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      width: 100%;
      height: 60%;
      background: #7e93ce;
      transform: skewY(-18deg);
      @include rwd($RWD_TABLET_SMALL) {
        transform: skewY(-10deg);
      }
    }

    &:before {
      top: -40%;
      @include rwd($RWD_DESKTOP) {
        top: -36%;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        top: -35%;
      }
    }

    &:after {
      bottom: -40%;
      @include rwd($RWD_DESKTOP) {
        bottom: -36%;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        bottom: -35%;
      }
    }
  }

  &__logotype {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 88%;
    max-width: 400px;
    transform: translate(-50%, -50%);
    @include use-fixed-ratio(691, 345);
    @include rwd($RWD_TABLET_SMALL) {
      width: 75%;
      max-width: 490px;
    }
    @include rwd($RWD_TABLET) {
      margin-top: -8px;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: -25px;
      margin-left: 20px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      max-width: 545px;
      margin-top: -50px;
    }

    &-left {
      position: absolute;
      top: -25%;
      left: -6%;
      width: 35%;
      transform-origin: center bottom;
      animation: observe-left 4s ease-in-out 1s infinite;
      @include use-fixed-ratio(959, 664);
      @include rwd($RWD_TABLET_SMALL) {
        left: -15%;
        top: -40%;
        width: 40%;
      }
      @include rwd($RWD_TABLET_SMALL) {
        left: -15%;
        top: -30%;
      }
      @include rwd($RWD_DESKTOP) {
        left: -43%;
        top: 18%;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        left: -58%;
        top: 25%;
        width: 53%;
      }
    }

    &-right {
      position: absolute;
      bottom: -57%;
      right: 0;
      width: 27%;
      transform-origin: center bottom;
      animation: observe-right 6s ease-in-out 1s infinite;
      @include use-fixed-ratio(806, 1002);
      @include rwd($RWD_TABLET_SMALL) {
        bottom: -75%;
        right: -10%;
        width: 32%;
      }
      @include rwd($RWD_TABLET) {
        bottom: -60%;
        right: -15%;
      }
      @include rwd($RWD_DESKTOP) {
        bottom: -45%;
        right: -34%;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        bottom: -81%;
        right: -34%;
        width: 41%;
      }
    }
  }

  &__intro {
    position: relative;
    left: 50%;
    width: 90%;
    max-width: 290px;
    margin-top: 1em;
    color: white;
    text-align: left;
    transform: translateX(-50%);
    @include rwd($RWD_IPHONE_678) {
      margin-top: 2.5em;
    }
    @include rwd($RWD_TABLET_SMALL) {
      max-width: 445px;
      margin-top: 0;
    }
    @include rwd($RWD_TABLET) {
      max-width: 490px;
      margin-top: -1em;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: 0;
      margin-left: 20px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: -3.5em;
    }

    &-text {
      font-size: 0.875em;
      font-weight: 600;
      line-height: 1.429em;
      letter-spacing: 0.1em;
      @include rwd($RWD_TABLET_SMALL) {
        font-size: 1.125em;
        line-height: 1.667em;
      }
    }
  }

  &__scroll {
    position: relative;
    width: 60px;
    margin: 1em auto;
    color: white;
    text-align: center;
    line-height: 20px;
    background: transparent;
    user-select: none;
    animation: jumping 1s ease-in-out infinite;
    cursor: pointer;
    @include rwd($RWD_IPHONE_678) {
      margin-top: 50px;
    }
    @include rwd($RWD_TABLET_SMALL) {}
    @include rwd($RWD_TABLET) {
      margin-top: 70px;
    }
    @include rwd($RWD_DESKTOP) {}
    @include rwd($RWD_DESKTOP_WIDE) {}

    &:active {
      transform: translateY(2px);
    }

    &-label {
      font-size: 0.75em;
      @include rwd($RWD_DESKTOP) {
        font-size: 0.875em;
      }
    }

    &-arrow {
      display: inline-block;
      position: relative;
      margin-top: 6px;
      width: 17px;
      height: 10px;
      @include use-fixed-ratio(24, 14);
      @include rwd($RWD_DESKTOP) {
        width: 23px;
        height: 14px;
        margin-top: 10px;
      }
    }
  }

  @keyframes jumping {
    0% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(6px);
    }
    60% {
      transform: translateY(6px);
    }
    100% {
      transform: translateY(0);
    }
  }

  @keyframes observe-left {
    0% {
      transform: skew(0deg, 0deg);
    }
    20% {
      transform: skew(0deg, 1deg);
    }
    40% {
      transform: skew(1deg, 0deg);
    }
    60% {
      transform: skew(1deg, 1deg);
    }
    80% {
      transform: skew(-1deg, -2deg);
    }
    100% {
      transform: skew(0deg, 0deg);
    }
  }

  @keyframes observe-right {
    0% {
      transform: skew(0deg, 0deg);
    }
    20% {
      transform: skew(1deg, 0deg);
    }
    40% {
      transform: skew(-1deg, 1deg);
    }
    60% {
      transform: skew(2deg, 1deg);
    }
    80% {
      transform: skew(-1deg, -1deg);
    }
    100% {
      transform: skew(0deg, 0deg);
    }
  }
}

.mobile {
  &.landscape {
    .poll-scene {
      &__scenario {
        margin-top: 20px;
        max-height: 300px;
      }

      &__logotype {
        max-width: 350px;
      }

      &__intro {
        margin-top: 50px;
      }

      &__scroll {
        margin-top: 10px;
      }
    }
  }
}

.desktop {
  .poll-scene {
    &__newspaper {
      background-attachment: fixed;
      background-size: cover;
    }
  }
}

// Inject by App.vue when viewport size 960&up + 768&down
.narrow-desktop {
  .poll-scene {
    &__scenario {
      margin-top: 20px;
      max-height: 450px;
    }

    &__logotype {
      max-width: 400px;
    }

    &__intro {
      margin-top: -50px;
    }

    &__scroll {
      margin-top: 10px;
    }
  }
}
</style>
